import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // 设置 全局 访问 state 对象
  state: sessionStorage.getItem('state') ? JSON.parse(sessionStorage.getItem('state')) : {
    currentUser: {}, // 用户信息
    innerWH: {}, // 可视区域 宽高
    offsetWidth: "", // 首页路径
  },
  // 唯一允许更改 state 里面得值
  mutations: {
    setCurrentUser(state, item) {
      state.currentUser = item;
    },
    setInnerWH(state, item) {
      state.innerWH = item;
    },
    setOffsetWidth(state, item) {
      state.offsetWidth = item;
    },
  },
  // 触发更改，处理异步任务
  actions: {
    setCurrentUserFun(context, item) {
      context.commit("setCurrentUser", item)
    },
    setInnerWHFun(context, item) {
      context.commit("setInnerWH", item)
    },
    setOffsetWidthFun(context, item) {
      context.commit("setOffsetWidth", item);
    },
  },
  // 实时监听 state 值得变化
  getters: {
    
    getCurrentUser: state => {
      return state.currentUser;
    },
    getInnerWH: state => {
      return state.innerWH;
    },
    getOffsetWidth: state => {
      return state.offsetWidth;
    },
  },
  modules: {
  }
})
